import React from "react";
import { Link } from "react-router-dom";

function EachWebsiteRightImage(props) {
return (
<>
    <div className="container-fluid d-flex align-items-center justify-content-between py-5 each-website-block text-start text-sm-end"
        style={{ background: `${props.websiteBgColor}`}}>
        <div className="row">
        <div className="col-md-6 my-auto order-1 order-sm-0 px-5">
                <h2 className="website-name" style={{ color: `${props.websiteTitleColor}` }}>
                    {props.websiteTitle}
                </h2>
                <p className="website-info mb-3 text-start text-sm-end ms-auto">{props.websiteInfo}</p>
                <p className="website-url  mb-3" style={{wordBreak: 'break-all'}}>{props.websiteURL}</p>

                <div className="mt-3">
                    <a className="button button-outline each-website-btn d-inline-block" target="_blank" href={`https://${props.websiteURL}`}
                        style={{ color: `${props.websiteTitleColor}`, boxShadow: `2px 4px 8px 2px ${props.websiteTitleColor}40` }}>
                    Visit website &rarr;
                    </a>
                </div>
            </div>
            <div className="col-md-6 mb-4">
                <img src={props.websiteBanner} alt="banner-img" className="img-responsive img-fluid moving-image"
                    style={{ borderRadius: " 25px" }} />
            </div>
          
        </div>
    </div>
</>
);
}

export default EachWebsiteRightImage;
